import { assertCreationDateMarker } from './assertCreationDateMarker';

export function ensureCreationDateMarker(name: unknown) {
  assertCreationDateMarker(name);
  return name;
}
